<template>
  <div class="login-form">
    <div class="login-form_title"><h2>登录</h2></div>
    <a-form-model ref="loginForm" :model="loginForm" :rules="rules" @submit="onSubmit" @submit.native.prevent>
      <a-form-model-item prop="username">
        <a-input v-model="loginForm.username" placeholder="账号" size="large">
          <a-icon slot="prefix" type="user" style="color: rgba(0, 0, 0, 0.25)" />
        </a-input>
      </a-form-model-item>
      <a-form-model-item prop="password">
        <a-input-password v-model="loginForm.password" placeholder="密码" size="large" @keyup.enter.native="onSubmit">
          <a-icon slot="prefix" type="lock" style="color: rgba(0, 0, 0, 0.25)" />
        </a-input-password>
      </a-form-model-item>
      <a-form-model-item>
        <a-button block size="large" type="primary" :loading="loading" @click="onSubmit"> 登录 </a-button>
        <a-button block size="large" style="margin-top: 12px" @click="onBack"> 返回 </a-button>
      </a-form-model-item>
    </a-form-model>
  </div>
</template>

<script>
import { userLdapLogin } from '@/api/system/auth';
export default {
  data() {
    return {
      loading: false,
      loginForm: {
        username: null,
        password: null
      },
      rules: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      }
    };
  },
  methods: {
    onBack() {
      this.$emit('back');
    },
    onSubmit() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true;
          userLdapLogin(this.loginForm)
            .then(response => {
              this.$message.success('登录成功');
              localStorage.setItem('token', response.data.token);
              localStorage.setItem('user_info', JSON.stringify(response.data.user_info));
              this.$store.dispatch('getPermissions');
              if (this.$router.currentRoute.query.url) {
                this.$router.push(this.$router.currentRoute.query.url);
              } else {
                this.$router.push('/');
              }
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.login-form {
  width: 100%;
  margin: 0 auto;
}

// .login-form_title {
//   font-size: 1.275rem;
//   line-height: 2.25rem;
//   font-weight: 700;
// }
</style>
